export default "__VITE_ASSET__BUxdZ2AX__"